import { Chip, Icon } from '@mui/material';
import React from 'react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const ArticleTags = ({ category, readtime, score }) => {
  const maxVisibleTags = 1;
  const remainingCount = category.length - maxVisibleTags;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingRight: '16px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {category.slice(0, maxVisibleTags).map((title) => (
          <Chip
            style={{ color: 'purple', marginRight: '8px' }}
            size="small"
            label={title.length > 10 ? title.slice(0, 10) + '...' : title}
            key={title}
          />
        ))}
        {remainingCount > 0 && (
          <Chip
            size="small"
            style={{ color: 'red' }}
            label={`+${remainingCount}`}
          />
        )}
      </div>
      |
      <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
        {readtime} min read
      </span>
      |
      <Icon component={MonetizationOnIcon} style={{ color: 'yellow' }} />
      <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
        {score ? score : 0} points
      </span>
    </div>
  );
};

export default ArticleTags;
